module.exports = __webpack_public_path__ + "img/forms-fresh.909777ed.png";